import { ActionReducerMap, MetaReducer, ActionReducer, Action } from '@ngrx/store';
import { localStorageSync } from 'ngrx-store-localstorage';

import { ROUTER_NAVIGATED, RouterNavigatedAction } from '@ngrx/router-store';
import { createEventsMetaReducer } from '@awp/google-tag';

import { environment } from '../../environments/environment';
import { ActionTypes, ThemeChangedAction } from './actions';
import { State } from './state';

export const reducers: ActionReducerMap<State> = {  };

export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return localStorageSync({
          keys: ['cardCheck', 'quote', 'data'], // This really needs to be based on the Feature Keys, possible should extract feature names somehow
          rehydrate: true,
          storage: sessionStorage,
      })(reducer);
}

export function clearState(reducer: ActionReducer<State>): ActionReducer<State> {
  return function(state: State, action: Action): State {
    if (action.type === ActionTypes.RESET_STATE) {
      state = { } as State;
    }
    return reducer(state, action);
  };
}

const eventsMap = {
  [ROUTER_NAVIGATED]: (action: Action): any => {
    // Router Navigated Action
    return {
      hitType: 'pageview',
      page: (<RouterNavigatedAction>action).payload.event.url
    }
  },
  [ActionTypes.APP_THEME_CHANGED]: (action: ThemeChangedAction): any => {
    return {
      hitType: 'event',
      themeId: action.payload
    }
  }
};

let gtmMetaReducer = createEventsMetaReducer(eventsMap);

export function gtmReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return gtmMetaReducer(reducer);
}

// Todo: Do not include GTM in development mode
export const metaReducers: MetaReducer<State>[] = !environment.production
  ? [localStorageSyncReducer, clearState, gtmReducer]
  : [localStorageSyncReducer, clearState, gtmReducer];
